module.exports = __webpack_public_path__ + "img/small.4f1d3406.jpg";